import axios from 'axios';
import { globalData, globalConf } from "@olmokit/core/data";
import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import { activeStepOnclick, updateStepparams, updateStepparamsRetire, getUrlParamGuest } from "components/Checkout";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);
import "./index.scss";

/**
 * Component: CheckoutShipping
 */
export function CheckoutShipping() {
  console.log("CheckoutShipping mounted.");

  const cmsApiUrl = globalConf.cmsApiUrl;
  const locale = globalConf.locale;
  const user = globalData.user;
  const cartid = globalData.cartid;
  const acc = $all(".step");
  const $checkoutAddressesShipping = $('.CheckoutAddresses:shipping');
  const $checkoutAddressesBilling = $('.CheckoutAddresses:billing_shipping');

  const guest = getUrlParamGuest();

  const $methodPayments = $all('.method:');
  const $address = $all('.CheckoutAddresses:');

  // Remove checkbox on addresse if click retire in the shop option
  forEach($methodPayments, (method) => {
    on(method, 'click', (e) => {      
      const input = $('input', method);      
      if(input.value == 'retire'){
        console.log('input.name', input.name);
        console.log('ciao')
        const $formControl = $('.formControl[name="addresses_billing"]');
        $formControl.checked = false
        forEach($address, (address) => {
          const $inputAddress = $('input', address);   
          $inputAddress.checked = false
        });
      }
    })
  })

  const config = {
    headers: {
        ...(!guest) && {"x-token": user.token},
        ...(guest) && {"x-guest": guest},
        "Content-Type": "application/json"
    }
  };

  const data = {
    code: null,
    cart_id: cartid
  };  

  const $errors = $('.CheckoutShipping:error');
  const $forward = $('#CheckoutShipping:forward');
  const $methods = $all("[name='shippingmethod']");
  on($forward, 'click', () => {

    removeClass(acc[1], 'active');
    removeClass(acc[1].nextElementSibling, 'activeStep');

    forEach($methods, (method) => {
      if(method.checked){
        data['code'] = method.value;
      }
    });

    axios.post(cmsApiUrl+'/'+locale+'/shoppingcart/shippingmethod', data, config).then((e) => {
      const { data } = e;
      console.log('data', data);
      addClass(acc[2].nextElementSibling, 'activeStep');
      activeStepOnclick(2);
      updateStepparams({step: 2});
      removeClass($errors, 'showError');

      if(data[1] == 'retire' || data['code'] == 'retire'){
        addClass($checkoutAddressesShipping, 'noAddressShipping');
        addClass($checkoutAddressesBilling, 'noAddressShipping');
        updateStepparamsRetire();
      } else {
        removeClass($checkoutAddressesShipping, 'noAddressShipping');
        removeClass($checkoutAddressesBilling, 'noAddressShipping');
      }
      
      gsap.to(window, { duration: 0.3, scrollTo: { y: acc[2], offsetY: 90 } });

      localStorage.setItem("cart-shipping", JSON.stringify(data)); 
    }).catch(error => {

      addClass(acc[1].nextElementSibling, 'activeStep');
      addClass($errors, 'showError');

    });

  });

  const $backward = $('#CheckoutShipping:backward');
  on($backward, 'click', () => {
    
    addClass(acc[0], 'active');
    addClass(acc[0].nextElementSibling, 'activeStep');    
    activeStepOnclick(0);
    updateStepparams({step: 0});
    removeClass(acc[1], 'active');
    removeClass(acc[1].nextElementSibling, 'activeStep');        
    
    gsap.to(window, { duration: 0.3, scrollTo: { y: acc[0], offsetY: 90 } });

  });  
  
}
